import { render, staticRenderFns } from "./PartPanel.vue?vue&type=template&id=638bd373&scoped=true&"
import script from "./PartPanel.vue?vue&type=script&lang=js&"
export * from "./PartPanel.vue?vue&type=script&lang=js&"
import style0 from "./PartPanel.vue?vue&type=style&index=0&id=638bd373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bd373",
  null
  
)

export default component.exports